import React, { ReactNode } from 'react';
import { Grid, Typography } from '@mui/material';
import Tippy from '@tippyjs/react';
import ClickableList from './ClickableList';

const appendToBody = () => document.body;

interface SelectionPopupProps<T> {
  title: string;
  visible: boolean;
  onClickOutside: () => void;
  items: T[];
  initialSelectedId?: string | number;
  renderItem: (item: T) => ReactNode;
  getItemKey: (item: T) => any;
  onItemClick: (val: any) => Promise<boolean>;
  checkmarkIcon?: ReactNode;
  children: React.ReactElement;
}

function SelectionPopup<T>({
  title,
  visible,
  onClickOutside,
  items,
  initialSelectedId,
  renderItem,
  getItemKey,
  onItemClick,
  checkmarkIcon,
  children,
}: SelectionPopupProps<T>) {
  return (
    <Tippy
      content={
        <Grid container>
          <Typography variant='p18SemiBold' color='secondary.dark'>
            {title}
          </Typography>
          <ClickableList
            divider
            spacing='flush'
            selectionIndicator='checkmark'
            checkmarkIcon={checkmarkIcon}
            items={items}
            initialSelectedId={initialSelectedId}
            renderItem={renderItem}
            getItemKey={getItemKey}
            onItemClick={onItemClick}
          />
        </Grid>
      }
      placement='bottom'
      arrow={false}
      trigger='click'
      interactive
      visible={visible}
      onClickOutside={onClickOutside}
      appendTo={appendToBody}
      theme='tippy-rounded'>
      {children}
    </Tippy>
  );
}

export default SelectionPopup;
